import styled from 'styled-components'
import { AmorinWiseBackground, WicanderBackground } from '../../../assets'

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`

export const AmorimWise = styled.div`
  position: relative;
  width: 50%;
  height: 100%;
  transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  background: url(${AmorinWiseBackground}) no-repeat;
  background-position: center center;
  background-size: cover;

  :after {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    background-color: rgba(29, 55, 57, 0.8);
    transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  }

  &.stretch {
    width: 75%;

    :after {
      background-color: rgba(29, 55, 57, 0.55);
    }
  }

  &.shrink {
    width: 25%;
  }
`

export const Wicanders = styled.div`
  position: relative;
  width: 50%;
  height: 100%;
  transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  background: url(${WicanderBackground}) no-repeat;
  background-position: center center;
  background-size: cover;

  :before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    opacity: 1;
    background-image: linear-gradient(90deg, rgba(0,0,0,.7), transparent);
    transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  }

  :after {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    background-color: rgba(29, 55, 57, 0.8);
    transition: all .6s cubic-bezier(0.59,-0.01, 0.29, 0.96);
  }

  &.stretch {
    width: 75%;
    :after {
      background-color: rgba(29, 55, 57, 0.55);
    }
    :before {
      opacity: .5;
    }
  }

  &.shrink {
    width: 25%;
    background-position: 0 0;
  }
`

export const ContainerContent = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  left: 46px;
  bottom: 22px;
  width: 300px;
  height: 400px;
  z-index: 2;

  &.content-right {
    left: initial;
    right: 46px;
    width: 250px;
  }
`

export const Text = styled.p`
  font-family: 'Amorim Sans Book', sans-serif;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 1.9px;
  color: #FFF;
  margin: 0;
`

export const BigText = styled.div`
  width: ${p => p.width}px;
  height: 28px;
  margin: 0;
  margin-top: 40px;
  background: url(${p => p.src}) no-repeat;
  background-size: contain;

  &.pos-right {
    position: relative;
    right: -44px;
    margin-bottom: 46px;
  }
`

export const ButtonStartVisit = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
  font-family: 'Amorim Sans Book', sans-serif;
  font-size: 24px;
  letter-spacing: .9px;
  color: #FFF;
  min-width: 250px;
  height: 40px;

  &.pos-right {
    display: flex;
    justify-content: flex-end;
    width: 300px;
    position: absolute;
    right: -20px;
  }

  @media (min-width: 768px){
    min-width: 300px;
  }

  &:hover {
    cursor: pointer;
    > div {
      margin-left: 16px;
    }
  }
`

export const Arrow = styled.div`
  width: 30px;
  height: 10px;
  mask: url(${p => p.background}) no-repeat;
  background: #FFF;
  margin-left: 10px;
  transition: all .2s ease-out;
`